// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__wdDvj","title":"index_title__rbRO9","desc":"index_desc__4KSVx","list":"index_list__dRYhR"};